import SegmentedControl from './segmented-control';

const uniforms = document.querySelectorAll<HTMLElement>('.uniform');

if (uniforms.length > 0) {
	const segmentedControl = new SegmentedControl('Uniformauswahl', uniforms);
	segmentedControl.render(uniforms[0]);
}
